import {ILeadModalLeadType} from "../../../../lead/types/ILeadModalLeadType";

export const getGtmEcommerceOfferEventCategoryByLeadType = (leadType: ILeadModalLeadType) => {
    return leadType === "conversation" ? "conversation_form" : "standard";
};
import {ILeadModalLeadType} from "../../../../lead/types/ILeadModalLeadType";

export const getGtmEcommerceOfferEventCategoryByLeadType = (leadType: ILeadModalLeadType) => {
    return leadType === "conversation" ? "conversation_form" : "standard";
};
